import routeBuilder from './routes';
const view = {
  layout: 'Masonry',
  routeBuilder,
};
export default view;
